<form [formGroup]="form" class="metatiedot-form">
  <mat-form-field>
    <mat-label>Toimittajan nimi</mat-label>
    <input matInput formControlName="toimittaja" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Y-tunnus / VAT kuten tositteessa</mat-label>
    <input matInput formControlName="businessId" />
    <mat-hint>{{ johdettuTunnusTyyppi ? 'Tulkitaan: ' + johdettuTunnusTyyppi : form.controls.businessId.value.trim() ? 'Tunnuksen muotoa ei tunnisteta, tyyppiä ei pisteytetä' : businessIdTyhjaHint }}</mat-hint>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ paivamaaraLabel }}</mat-label>
    <input matInput formControlName="paivamaara" placeholder="2026-01-31" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ summaLabel }}</mat-label>
    <input matInput type="number" step="0.01" formControlName="summa" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Tyyppi</mat-label>
    <mat-select formControlName="tyyppi">
      <mat-option value="">Ei arvioida</mat-option>
      <mat-option value="ostolasku">Ostolasku</mat-option>
      <mat-option value="kuitti">Kuitti</mat-option>
    </mat-select>
    <mat-hint>Arvioidaan vain webin ja mobiilin luvussa</mat-hint>
  </mat-form-field>
  @if (naytaToimittajaValinta) {
    <mat-form-field class="metatiedot-form__toimittaja-valinta">
      <mat-label>Odotettu toimittaja rekisterissä</mat-label>
      <mat-select formControlName="toimittajaValinta">
        <mat-option [value]="toimittajaValintaAutomaattinen">Automaattinen (tunnuksella tai nimellä)</mat-option>
        <mat-option [value]="toimittajaValintaEiRekisterissa">Ei rekisterissä (mallilta odotetaan null)</mat-option>
        @for (toimittaja of toimittajaRekisteri; track toimittaja.avain) {
          <mat-option [value]="toimittaja.avain">{{ toimittaja.nimi }} (#{{ toimittaja.numero }}){{ toimittaja.tunnisteet.length ? ' – ' + toimittaja.tunnisteet.join(', ') : '' }}</mat-option>
        }
      </mat-select>
      @if (odotettuToimittajaHint !== null) {
        <mat-hint>Pisteytyksessä odotetaan: {{ odotettuToimittajaHint }}</mat-hint>
      }
    </mat-form-field>
  }
</form>
